import { observer } from 'mobx-react';
import { L, T } from '../../../../../Translations';

interface Props {
  date: Date;
}

function ExpireOn({ date }: Props) {
  if (date < new Date()) {
    return (
      <T kind="Expired <date/>" date={<L localizeable={date} format="short-month-day-year" />} />
    );
  } else {
    return (
      <T kind="Expires <date/>" date={<L localizeable={date} format="short-month-day-year" />} />
    );
  }
}

export default observer(ExpireOn);
